import { ChipProps } from '@mui/material';

import { CaclRiskScore } from '@/generated/gql/graphql';

const riskScoreColorMap: { [key in CaclRiskScore]: ChipProps['color'] } = {
  [CaclRiskScore.HIGH]: 'error',
  [CaclRiskScore.MEDIUM]: 'warning',
  [CaclRiskScore.LOW]: 'success',
  [CaclRiskScore.UNKNOWN]: 'default',
};
export const statusColorFromRiskScore = (value: CaclRiskScore): ChipProps['color'] => {
  return riskScoreColorMap[value];
};
